import { createContext, useContext } from "react";
export const MapContext = createContext(undefined);
export function useMapContext() {
    const ctx = useContext(MapContext);
    if (!ctx)
        throw new Error("No map context found");
    return ctx;
}
export function useMap() {
    const { map } = useMapContext();
    if (!map)
        throw new Error("No map found in map context");
    return map;
}
